import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { countriescodes } from '@/assets/constants/countriescodes';
import { DropdownIcon } from '@/assets/images';
import AppText from '../AppText';
import './mobileInput.scss';

const AppMobileInput = ({
   label,
   id = 'phone',
   value,
   selectedCountryCode,
   onNumberChange,
   onCountryChange,
   placeholder,
   required = false,
   maxLength = 15,
   className = '',
}) => {
   const selectedCountry = useMemo(
      () => countriescodes.find(c => c.code === selectedCountryCode) || countriescodes[0],
      [selectedCountryCode],
   );

   const handleNumberChange = e => {
      const val = e.target.value.replace(/\D/g, '');
      if (val.length <= maxLength) {
         onNumberChange(val);
      }
   };

   return (
      <div className={`app-input-group ct-flex ct-fcol ${className}`}>
         {label && (
            <AppText as="label" htmlFor={id} className="app-input-label">
               {label}
               {required && <span className="required-mark">*</span>}
            </AppText>
         )}
         <div className="mobile-input-container ct-flex ct-aiCenter ct-fnowrap">
            <div className="country-selector-wrapper ct-flex ct-aiCenter ct-relative ct-cursor">
               <span className="flag-icon ct-flexCenter prefix">{selectedCountry.code}</span>
               <span className="prefix">{selectedCountry.dial_code}</span>
               <DropdownIcon className="dropdown-arrow ct-icon" />
               <select
                  className="hidden-country-select"
                  value={selectedCountryCode}
                  onChange={e => onCountryChange(e.target.value)}
               >
                  {countriescodes.map(country => (
                     <option value={country.code} key={country.code}>
                        {country.name} ({country.dial_code})
                     </option>
                  ))}
               </select>
            </div>
            <div className="vertical-divider ct-divider gray" />
            <input
               type="tel"
               id={id}
               className="ct-flex1"
               placeholder={placeholder}
               value={value}
               onChange={handleNumberChange}
               required={required}
               maxLength={maxLength}
            />
         </div>
      </div>
   );
};

AppMobileInput.propTypes = {
   label: PropTypes.string,
   id: PropTypes.string,
   value: PropTypes.string.isRequired,
   selectedCountryCode: PropTypes.string.isRequired,
   onNumberChange: PropTypes.func.isRequired,
   onCountryChange: PropTypes.func.isRequired,
   placeholder: PropTypes.string,
   required: PropTypes.bool,
   className: PropTypes.string,
   maxLength: PropTypes.number,
};

export default AppMobileInput;
